module.exports = __webpack_public_path__ + "static/media/add.60ac0539.svg";